<div class="flex flex-col md:flex-row flex-wrap gap-4 md:gap-6">
    <div class="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 flex-grow">
        <div class="min-w-[120px]">
            <p class="m-0 mb-2 typography-body-m-medium">
                {{'global.warehouse' | translate}}:
            </p>
            <app-select
                [options]="centerOptions()"
                [isClearable]="false"
                [selectedValue]="selectedCenterValue()"
                [searchable]="false"
                (selectedValueChanged)="changeCenter($event)"
            ></app-select>
        </div>
        <div class="min-w-[120px]">
            <p class="m-0 mb-2 typography-body-m-medium">
                {{'brand' | translate}}:
            </p>
            <app-select
                [placeholder]="'select' | translate"
                [options]="brandOptions()"
                [selectedValue]="selectedBrandValue()"
                [searchable]="false"
                (selectedValueChanged)="changeBrand($event)"
            ></app-select>
        </div>

        <div class="min-w-[120px]">
            <p class="m-0 mb-2 typography-body-m-medium">
                {{'global.finish' | translate}}:
            </p>
            <app-select
                [placeholder]="'select' | translate"
                [options]="finishOptions()"
                [selectedValue]="selectedFinishValue()"
                [searchable]="false"
                (selectedValueChanged)="changeFinish($event)"
            ></app-select>
        </div>

        <div class="min-w-[120px]">
            <p class="m-0 mb-2 typography-body-m-medium">
                {{'global.thickness' | translate}}:
            </p>
            <app-select
                [placeholder]="'select' | translate"
                [options]="thicknessOptions()"
                [selectedValue]="selectedThicknessValue()"
                [searchable]="false"
                (selectedValueChanged)="changeThickness($event)"
            ></app-select>
        </div>

    </div>

<!--    <div class="min-w-[120px]">-->
<!--        <p class="m-0 mb-2 typography-body-m-medium">-->
<!--            {{'natural_stone.group' | translate}}:-->
<!--        </p>-->
<!--        <app-select-->
<!--            [placeholder]="'select' | translate"-->
<!--            [options]="priceGroupOptions()"-->
<!--            [selectedValue]="selectedPriceGroupValue()"-->
<!--            [searchable]="false"-->
<!--            (selectedValueChanged)="changePriceGroup($event)"-->
<!--        ></app-select>-->
<!--    </div>-->

    <div class="flex-1 flex flex-col justify-end">
        <div class="flex flex-wrap md:flex-nowrap gap-4 md:gap-6">
            <div class="flex-1">
                <app-search-input
                    [placeholder]="'global.enter_your_search' | translate"
                    (valueChange)="changeSearchString($event)"

                ></app-search-input>
            </div>
            <div class="flex items-center">
                <span class="typography-body-m-medium text-text-secondary whitespace-nowrap">
                    {{'global.order_by' | translate}}:&nbsp;
                </span>
                <div class="min-w-[120px]">
                    <app-select
                        [ghost]="true"
                        [options]="orderByOptions()"
                        [selectedValue]="selectedOrderByValue()"
                        [searchable]="false"
                        [isClearable]="false"
                        (selectedValueChanged)="changeOrderBy($event)"
                    ></app-select>
                </div>
            </div>
        </div>
    </div>
</div>